import AuthCard from "../components/AuthCard"
import Button from "../components/Button"
import { useDispatch } from "react-redux"
import { logout } from "../app/features/userSlice"
import { useNavigate } from "react-router-dom"

function BlockedScreen() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = () => {
    dispatch(logout())
    navigate("/")
  }

  return (
    <AuthCard>
      <h1>Vagas Esgotadas</h1>
      <h2>Não estamos aceitando novas assinaturas no momento.</h2>
      <Button onClick={handleLogout} text="Sair da conta" />
    </AuthCard>
  )
}

export default BlockedScreen
